//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "../services/package.js";
export default {
  name: "Package",
  data() {
    return {
      userid: 0,
      username: "",
      sum_qt: 0,
      sum_vn: 0,
      sum_point: 0,
      sum_vn_point: 0,
      datavn: [],
      infor: [],
      data: [],
      columns: [
        {
          sortable: true,
          name: "Shop_id",
          align: "center",
          label: "Shop ID",
          field: "id",
          headerClasses: "bg-indigo-12 text-white"
        },
        {
          name: "Shop_name",
          align: "center",
          label: "Shop Name",
          field: "name",
          headerClasses: "bg-indigo-12 text-white"
        },
        {
          sortable: true,
          name: "Total_orders",
          align: "center",
          label: "Số đơn",
          field: "orders",
          headerClasses: "bg-indigo-12 text-white"
        },
        {
          sortable: true,
          name: "Point",
          align: "center",
          label: "Số điểm",
          field: "point",
          headerClasses: "bg-indigo-12 text-white"
        }
      ],
      shop: [],
      options: ["SILVER", "GOLD", "PLATINUM"],

      tab: "one",
      map_package: {
        SILVER: "1",
        GOLD: "2",
        PLATINUM: "3",
        PLUS: "6",
        VIPPLUS: "7"
      }
    };
  },

  methods: {
    async submit() {
      var i, u;
      this.infor = []
      this.data = []

      api
        .getInfo(this.username)
        .then(response => {
          this.sum_vn = 0;
          this.sum_qt = 0;
          this.sum_point = 0;
          this.sum_vn_point = 0;
          this.infor = response.data.user;
          this.data = response.data.shopGlobal;
          this.datavn = response.data.shopVn;

          this.userid = this.infor.id;

          for (i = 0; i < this.data.length; i++) {
            this.sum_qt += parseInt(this.data[i].orders);
            this.sum_point += parseInt(this.data[i].point);
          }
          for (u = 0; u < this.datavn.length; u++) {
            this.sum_vn += parseInt(this.datavn[u].orders);
            this.sum_vn_point += parseInt(this.datavn[u].point);
          }
        })

        .catch(err => {

          this.$q.notify({
            type: "negative",
            message: err.data.message,
            color: "red",
            position: "bottom",
            icon: "report_problem"
          });
        });
    },
    radio() {
      this.$q
        .dialog({
          title: "Nâng hạng",
          message: "Hạng Trung Quốc :)",
          options: {
            type: "radio",
            model: this.map_package[this.infor.package_qt],
            isValid: val => val !== this.map_package[this.infor.package_qt],
            // inline: true
            items: [
              { label: "Silver", value: "1", color: "indigo-12" },
              { label: "Gold", value: "2", color: "indigo-12" },
              { label: "Platinum", value: "3", color: "indigo-12" }
            ]
          },
          cancel: true,
          persistent: true
        })
        .onOk(opt => {
          let formData = new FormData();
          formData.append("uid", this.userid);
          formData.append("pid", opt);
          api
            .updatePackage(formData)
            .then(response => {
              console.log(response.data);
              if (response.data.status) {
                if (opt == 1) {
                  this.infor.package_qt = "SILVER";
                } else if (opt == 2) {
                  this.infor.package_qt = "GOLD";
                } else if (opt == 3) {
                  this.infor.package_qt = "PLATINUM";
                }
              }
            })

            .catch(() => {
              this.$q.notify({
                color: "red",
                position: "bottom",
                message: "Có lỗi xảy ra",
                icon: "report_problem"
              });
            });
        });
    },
    radioVN() {
      this.$q
        .dialog({
          title: "Nâng hạng",
          message: "Hạng Vietnam :)",
          options: {
            type: "radio",
            model: this.map_package[this.infor.package_vn],
            isValid: val => val !== this.map_package[this.infor.package_vn],
            // inline: true
            items: [
              { label: "Plus", value: "6", color: "indigo-12" },
              { label: "VIP Plus", value: "7", color: "indigo-12" }
            ]
          },
          cancel: true,
          persistent: true
        })
        .onOk(opt => {
          console.log(this.package_vn);
          let formData = new FormData();
          formData.append("uid", this.userid);
          formData.append("pid", opt);
          api
            .updatePackageVn(formData)
            .then(response => {
              console.log(response.data);
              if (response.data.status) {
                if (opt == 6) {
                  this.infor.package_vn = "PLUS";
                } else if (opt == 7) {
                  this.infor.package_vn = "VIPPLUS";
                }
              }
            })

            .catch(() => {
              this.$q.notify({
                color: "red",
                position: "bottom",
                message: "Có lỗi xảy ra",
                icon: "report_problem"
              });
            });
        });
    }
  }
};
